// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__399lU","footer":"Form_footer__1CWpc"};